import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appDangerToast]'
})
export class DangerToastDirective {

    constructor(private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {
    }

    @Input() set appDangerToast(condition: boolean) {
        if (condition) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainerRef.clear();
        }
    }
}
